
import { Component } from '@angular/core';
import { NotificationService } from './notification.service';

@Component({
  selector: 'app-notification-service',
  templateUrl: './notification.service.pug',
  styleUrls: ['./notification.service.sass'],
})
export class NotificationComponent {

  constructor(public notificationService: NotificationService) {

  }
}



// WEBPACK FOOTER //
// ./src/app/common/notification.service/notification.service.component.ts